const fibromyalgia_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Evidence review",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"F[0].Page_1[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   // Removed from Fastvet on 3-18-2022
   // {
   //    "question":"Describe the history (including onset and course) of the ##name##'s fibromyalgia condition?",
   //    "sub":"(brief summary)",
   //    "type":"textarea",
   //    "show": true,
   //    "section": {
   //       page: "2",
   //       title: "MEDICAL HISTORY",
   //       number: "2A"
   //    },
   //    "options":[],
   //    "dbqName":"F[0].Page_2[0].Describe2[0]",
   //    "answer":""
   // },
   {
      "question":"Is continuous medication required for control of fibromyalgia symptoms?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2B"
      },
      "presidence":"Yes",
      "maxLength":90,
      "ref":0,
      "dbqName_yes":"F[0].Page_2[0].CheckBox37[0]",
      "dbqName_no":"F[0].Page_2[0].CheckBox37[1]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe the appliance",
      "textdbqName":"F[0].Page_2[0].TextField1[1]",
      "textanswer":""
   },
   {
      "question":"Is ##name## currently undergoing treatment for this condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2C"
      },
      "presidence":"Yes",
      "maxLength":90,
      "ref":0,
      "dbqName_yes":"F[0].Page_2[0].CheckBox37[2]",
      "dbqName_no":"F[0].Page_2[0].CheckBox37[3]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe the appliance",
      "textdbqName":"F[0].Page_2[0].TextField1[2]",
      "textanswer":""
   },
   {
      "question":"Are ##name##'s fibromyalgia symptoms refractory to therapy?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2D"
      },
      "presidence":"Yes",
      "maxLength":90,
      "ref":0,
      "dbqName_yes":"F[0].Page_2[0].CheckBox37[4]",
      "dbqName_no":"F[0].Page_2[0].CheckBox37[5]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe the appliance",
      "textdbqName":"F[0].Page_2[0].TextField1[3]",
      "textanswer":""
   },
   {
      "question":"Does ##name## currently have any findings, signs, or symptoms attributable to fibromyalgia?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "FINDINGS, SIGNS, AND SYMPTOMS",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":2,
      "dbqName_yes":"F[0].Page_2[0].CheckBox37[6]",
      "dbqName_no":"F[0].Page_2[0].CheckBox37[7]",
      "answer":"",
   },
   {
      "question":"check all the symptoms attributable to fibromyalgia, that apply",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "small": true,
      "cols": 2,
      "refId":1,
      "section": {
         page: "2",
         title: "FINDINGS, SIGNS, AND SYMPTOMS",
         number: "3A"
      },
      "questions":[
               {
                  "main":"Widespread musculoskeletal pain",
                  "dbqName":"F[0].Page_2[0].amp2[0]",
                  "answer":""
               },
               {
                  "main":"Stiffness",
                  "dbqName":"F[0].Page_2[0].amp3[0]",
                  "answer":""
               },
               {
                  "main":"Muscle weakness",
                  "dbqName":"F[0].Page_2[0].amp4[0]",
                  "answer":"",
                  "textarea": true,
                  "maxLength":85,
                  "textdbqName" : "F[0].Page_2[0].CommentsIfAny[0]",
                  "placeholder": "describe",
                  "textAnswer": ""
               },
               {
                  "main":"Fatigue",
                  "dbqName":"F[0].Page_2[0].Yes2[0]",
                  "answer":""
               },
               {
                  "main":"Sleep disturbances",
                  "dbqName":"F[0].Page_2[0].amp3[1]",
                  "answer":""
               },
               {
                  "main":"Paresthesias",
                  "dbqName":"F[0].Page_2[0].leftie2[0]",
                  "answer":""
               },
               {
                  "main":"Headache",
                  "dbqName":"F[0].Page_2[0].leftie3[0]",
                  "answer":""
               },
               {
                  "main":"Depression",
                  "dbqName":"F[0].Page_2[0].leftie3[2]",
                  "answer":""
               },
               {
                  "main":"Anxiety",
                  "dbqName":"F[0].Page_2[0].leftie3[3]",
                  "answer":""
               },
               {
                  "main":"Irritable bowel symptoms ",
                  "dbqName":"F[0].Page_2[0].leftie3[1]",
                  "answer":""
               },
               {
                  "main":"Raynaud's-like symptoms",
                  "dbqName":"F[0].Page_2[0].Yes6[0]",
                  "answer":""
               },
               {
                  "main":"Other",
                  "dbqName":"F[0].Page_2[0].leftie6a[0]",
                  "answer":"",
                  "textarea": true,
                  "maxLength":60,
                  "textdbqName" : "F[0].Page_2[0].DescribeOther1[0]",
                  "placeholder": "describe",
                  "textAnswer": ""
               }         
            ],
            "answer":""
   },
   {
      "question":"For all the symptoms checked on the previous screen, please describe",
      "sub":"",
      "type":"textarea",
      "show": false,
      "refId":2,
      "section": {
         page: "2",
         title: "FINDINGS, SIGNS, AND SYMPTOMS",
         number: "3A"
      },
      "options":[],
      "dbqName":"F[0].Page_2[0].CommentsIfAny[1]",
      "answer":""
   },
   {
      "question":"Frequency of fibromyalgia symptoms",
      "sub":"(check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "FINDINGS, SIGNS, AND SYMPTOMS",
         number: "3B"
      },
      "questions":[
         {
            "main":"No symptoms",
            "dbqName":"F[0].Page_3[0].Yes2[0]",
            "answer":""
         },
         {
            "main":"Episodic with exacerbations",
            "dbqName":"F[0].Page_3[0].Yes2[1]",
            "answer":""
         },
         {
            "main":"Present more than one-third of the time",
            "dbqName":"F[0].Page_3[0].Yes2[2]",
            "answer":""
         },
         {
            "main":"Constant or nearly constant",
            "dbqName":"F[0].Page_3[0].Yes2[3]",
            "answer":""
         },
         {
            "main":"Often precipitated by environmental or emotional stress or overexertion",
            "dbqName":"F[0].Page_3[0].Yes2[4]",
            "answer":"",
            "textarea": true,
            "maxLength":170,
            "textdbqName" : "F[0].Page_3[0].CommentsIfAny[0]",
            "placeholder": "describe",
            "textAnswer": ""
         },
         {
            "main":"Other",
            "dbqName":"F[0].Page_3[0].Yes2[5]",
            "answer":"",
            "textarea": true,
            "maxLength":250,
            "textdbqName" : "F[0].Page_3[0].CommentsIfAny[1]",
            "placeholder": "describe",
            "textAnswer": ""
         }         
      ],
      "answer":""
   },
   {
      "question":"Does ##name## have tender points (trigger points) for pain present?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "FINDINGS, SIGNS, AND SYMPTOMS",
         number: "3C"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_3[0].CheckBox37[0]",
      "dbqName_no":"F[0].Page_3[0].CheckBox37[1]",
      "answer":"",
   },
   {
      "question":"Indicate all the tender points (trigger points) for pain present",
      "sub":"If yes, indicate side affected",
      "type":"checkbox",
      "multi": true,
      "small": true,
      "show": false,
      "refId":1,
      "cols": 1,
      "section": {
         page: "3",
         title: "FINDINGS, SIGNS, AND SYMPTOMS",
         number: "3C"
      },
      "questions":[
         {
            "main":"All bilaterally",
            "dbqName":"F[0].Page_3[0].Yes2[6]",
            "answer":""
         },
         {
            "main":"Low cervical region: at anterior aspect of the interspaces between transverse processes of C5-C7",
            "dbqName":"F[0].Page_3[0].Yes2[7]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_3[0].RIGHT[0]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_3[0].Left[0]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_3[0].Left[1]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Second rib: at second costochondral junction",
            "dbqName":"F[0].Page_3[0].Yes2[8]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_3[0].RIGHT[1]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_3[0].Left[2]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_3[0].Left[3]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Occiput: at suboccipital muscle insertion",
            "dbqName":"F[0].Page_3[0].Yes2[9]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_3[0].RIGHT[2]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_3[0].Left[4]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_3[0].Left[5]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Trapezius muscle: midpoint of upper border",
            "dbqName":"F[0].Page_3[0].Yes2[10]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_3[0].RIGHT[3]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_3[0].Left[6]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_3[0].Left[7]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Supraspinatus muscle: above medial border of the scapular spine",
            "dbqName":"F[0].Page_3[0].Yes2[11]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_3[0].RIGHT[4]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_3[0].Left[8]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_3[0].Left[9]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Lateral epicondyle: 2 cm distal to lateral epicondyle",
            "dbqName":"F[0].Page_3[0].Yes2[12]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_3[0].RIGHT[5]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_3[0].Left[10]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_3[0].Left[11]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Gluteal: at upper outer quadrant of buttocks",
            "dbqName":"F[0].Page_3[0].Yes2[13]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_3[0].RIGHT[6]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_3[0].Left[12]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_3[0].Left[13]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Greater trochanter: posterior to greater trochanteric prominence",
            "dbqName":"F[0].Page_3[0].Yes2[14]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_3[0].RIGHT[7]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_3[0].Left[14]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_3[0].Left[16]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Knee: medial joint line",
            "dbqName":"F[0].Page_3[0].Yes2[15]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_3[0].RIGHT[8]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_3[0].Left[15]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_3[0].Left[17]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Other",
            "dbqName":"F[0].Page_3[0].Yes2[16]",
            "answer":"",
            "text1": "",
            "maxLength":25,
            "dbqName1": "F[0].Page_3[0].DescribeOther1[0]",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"F[0].Page_3[0].RIGHT[9]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"F[0].Page_3[0].Left[18]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"F[0].Page_3[0].Left[19]",
                  "answer":""
               }
            ],
         },       
      ],
      "answer":""
   },
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":1780,
      "show": true,
      "section": {
         page: "5",
         title: "REMARKS",
         number: "8A"
      },
      "options":[],
      "dbqName":"F[0].Page_5[0].REMARKSIfany[0]",
      "answer":""
   },
]
   
    export default fibromyalgia_questions ;